var fixedThreshold = 20;

$(document).ready(function() {
  $(window).resize(setCategoriaMaxHeight);
});

function setCategoriaMaxHeight() {
  return setMaxHeight($('.categoria-lista:visible'));
}
  
function setMaxHeight(element) {
  if (!element || !element.length) {
  	return false; 
  }
  element.css({ maxHeight: getRemainingHeight(element) + 'px', overflowY: 'auto' })
}

function getRemainingHeight(element) {
  var browseSize = $('.browse-option:visible').outerHeight();
  var calc = $(window).outerHeight() - element.offset().top - fixedThreshold;
  return Math.max(calc, browseSize); 
}
